import { render } from "./TheNavbar.vue?vue&type=template&id=228b124a"
import script from "./TheNavbar.vue?vue&type=script&lang=js"
export * from "./TheNavbar.vue?vue&type=script&lang=js"

import exportComponent from "/home/nick/GIT/hort-310-cutting-monitoring-simulation/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__